import {requests} from "../../helpers/api.services";
import {TARGET_GROUP_URL} from "../../helpers/api.routes";

export const AdminTargetGroupService = {
    get: ()=> requests.get(TARGET_GROUP_URL),
    create: (params: any)=> requests.post(TARGET_GROUP_URL, params, true),
    deleteSpecification: (id: number)=> requests.delete(`${TARGET_GROUP_URL}/specification/${id}`),
    deleteImage: ()=> requests.delete(`${TARGET_GROUP_URL}/image`),
    updatePosition: (ids: number[])=> requests.patch(TARGET_GROUP_URL, {ids})
}